<template>
  <div>
    <el-dialog
      :title="showSettlementDetail ? '结算详情' : '生成结算单'"
      :visible="templeShowDialog"
      width="80%"
      center
      @opened="handleOpen"
      @close="closeDialog"
    >
      <div v-show="!showSettlementDetail">
        <vxe-table
          ref="settlementRef"
          :data="tableData"
          :auto-resize="true"
          resizable
          border="outer"
          show-overflow
          show-header-overflow
          header-align="center"
          column-min-width="100"
          @radio-change="handleSelectionChange"
          :fit="true"
          :max-height="'400px'"
          style="margin-top: 20px; width: 100%"
        >
          <vxe-table-column type="checkbox" width="50" fixed="left"> </vxe-table-column>
          <vxe-table-column type="seq" title="序号" width="50"></vxe-table-column>
          <vxe-table-column
            type:html
            v-for="item in columnListDefault"
            :field="item.field"
            :title="item.title"
            :key="item.field"
          >
            <template v-slot="{ row }">
              <template v-if="item.field === 'currencyName'">{{
                row['currencyName'] ? row['currencyName'] : '中国人民币（国际）'
              }}</template>
              <template v-else-if="item.field === 'exchangeRate'">{{
                row['exchangeRate'] ? row['exchangeRate'] : '1'
              }}</template>
              <template v-else-if="item.field === 'originalTotalAmount'">{{
                row['originalTotalAmount'] ? row['originalTotalAmount'].toFixed(2) : ''
              }}</template>
              <template v-else-if="item.field === 'domesticTotalAmount'">{{
                row['domesticTotalAmount'] ? row['domesticTotalAmount'].toFixed(2) : ''
              }}</template>
              <template v-else-if="item.field === 'settlementType'">{{
                row.settlementType == '1' ? '预结算' : '终结算'
              }}</template>
              <template v-else-if="item.field === 'operate'">
                <a @click="showDetail(row)" href="#" style="color: blue; cursor: pointer"
                  >查看详情</a
                ></template
              >
              <template v-else>{{ row[item.field] }}</template>
            </template>
          </vxe-table-column>
        </vxe-table>
      </div>
      <div v-show="showSettlementDetail">
        <el-tabs type="border-card">
          <el-tab-pane label="结算行">
            <vxe-table
              ref="settleAccountsRef"
              :data="detailList"
              :auto-resize="true"
              resizable
              border="outer"
              show-overflow
              show-header-overflow
              header-align="center"
              column-min-width="100"
              @radio-change="detailHandleSelectionChange"
              :fit="true"
              :max-height="'200px'"
              style="margin-top: 20px; width: 100%"
            >
              <vxe-table-column type="radio" width="50" fixed="left"> </vxe-table-column>
              <vxe-table-column type="seq" title="序号" width="50"></vxe-table-column>
              <vxe-table-column
                v-for="item in tableLine"
                :field="item.field"
                :title="item.title"
                :key="item.field"
                ><template v-slot="{ row }">
                  <el-checkbox v-if="item.field == 'additional'" v-model="row[item.field]" />
                  <span v-else-if="item.field == 'unit'">{{
                    basic_unit?.find((item) => item.value == row['unit'])?.label
                  }}</span>
                  <span v-else-if="item.field == 'currencyName'">{{
                    row['currencyName'] ? row['currencyName'] : '中国人民币（国际）'
                  }}</span>
                  <span v-else-if="item.field == 'originalPrice'">{{
                    row['originalPrice'] != null && row['originalPrice'] != ''
                      ? row['originalPrice'].toFixed(4)
                      : ''
                  }}</span>
                  <span v-else-if="item.field == 'domesticAmount'">{{
                    row['domesticAmount'] != null && row['domesticAmount'] != ''
                      ? row['domesticAmount'].toFixed(2)
                      : ''
                  }}</span>

                  <span v-else>{{ row[item.field] }}</span>
                </template>
              </vxe-table-column>
            </vxe-table>
          </el-tab-pane>
        </el-tabs>
        <el-tabs type="border-card">
          <el-tab-pane label="结算明细">
            <vxe-table
              :data="currentSelectLine"
              :auto-resize="true"
              resizable
              border="outer"
              show-overflow
              show-header-overflow
              header-align="center"
              column-min-width="100"
              :fit="true"
              :max-height="'200px'"
              style="margin-top: 20px; width: 100%"
            >
              <vxe-table-column type="seq" title="序号" width="50"></vxe-table-column>
              <vxe-table-column
                v-for="item in tableLineDetail"
                :field="item.field"
                :title="item.title"
                :key="item.field"
              >
                <template v-slot="{ row }">
                  <span v-if="item.field == 'expenseType'">{{
                    expenseType?.find((item) => item.value == row['expenseType'])?.label
                  }}</span>
                  <span v-else-if="item.field == 'currencyName'">{{
                    row['currencyName'] ? row['currencyName'] : '中国人民币（国际）'
                  }}</span>
                  <span v-else-if="item.field == 'originalPrice'">{{
                    row['originalPrice']?.toFixed(4)
                  }}</span>
                  <span v-else>{{ row[item.field] }}</span>
                </template>
              </vxe-table-column>
            </vxe-table>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="cancel" plain>取消</el-button>
        <el-button v-show="!showSettlementDetail" type="primary" @click="save" :loading="load"
          >确认创建结算单</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import {
    tableColumnlineList,
    lineDetailList,
    settlementColumn,
  } from './batchCreateSettlementDialog.js';
  import parkPropertyApi from '@/api/receivablesAndPayables/parkProperty.js';
  import { mapState } from 'vuex';

  export default {
    name: 'BatchCreateGenerateDialog',
    props: {
      showDialog: {
        type: Boolean,
        default: false,
      },
      tableData: {
        type: Array,
        default: () => [],
      },
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      tableLine() {
        return tableColumnlineList;
      },
      tableLineDetail() {
        return lineDetailList;
      },
      columnListDefault() {
        return settlementColumn;
      },
      expenseType() {
        return this.$baseRequest.getDictListMapByType('property_settlement_cost');
      },
    },
    watch: {
      showDialog(var1, var2) {
        this.templeShowDialog = var2;
        this.templeShowDialog = var1;
      },
    },
    data() {
      return {
        showSettlementDetail: false,
        templeShowDialog: this.showDialog,
        multipleSelection: [],
        detailList: [],
        currentSelectLine: [],
        load: false,
      };
    },
    methods: {
      // 选中触发事件
      handleSelectionChange(row) {
        this.multipleSelection = row;
        console.log(row);
      },
      // 初始化数据
      handleOpen() {
        this.$refs.settlementRef.setAllCheckboxRow(true);
      },
      detailOpen() {
        this.$refs.settleAccountsRef.setRadioRow(this.detailList[0]);
      },
      // 关闭弹窗
      closeDialog() {
        this.showSettlementDetail = false;
        this.$emit('closeDialog', false);
      },
      detailHandleSelectionChange(row) {
        console.log('选中行的数据', row);
        this.currentSelectLine = row.row.lineDetails;
      },
      cancel() {
        if (this.showSettlementDetail) {
          this.showSettlementDetail = false;
          this.$refs.settlementRef.setAllCheckboxRow(true);
        } else {
          console.log('取消');
          this.$emit('closeDialog', false);
        }
      },
      // 保存数据
      async save() {
        let selectedList = this.$refs.settlementRef.getCheckboxRecords();
        if (!selectedList.length) {
          this.$message.warning('请选择行操作!');
          return;
        }
        let expenseIds = [];
        selectedList.forEach((item) => {
          item.lines.forEach((line) => {
            line.lineDetails.forEach((detail) => expenseIds.push(detail.id));
          });
        });

        const { data } = await this.$axios.post(
          parkPropertyApi.RECEIVABLESEXPENSE_AUTOGENERATE_SETTLEMENT,
          {
            oaId: this.userInfo.oaId,
            businessGroup: '园区',
            expenseIds: expenseIds,
          }
        );
        if (data.code == 0) {
          this.$message.success('创建成功！');
          this.$emit('save');
        } else {
          if (data.msg != null) {
            return this.$message.error(data.msg);
          }
          return this.$message.error('创建失败');
        }
      },
      showDetail(row) {
        this.detailList = row.lines;
        this.$refs.settleAccountsRef.setRadioRow(this.detailList[0]);
        this.currentSelectLine = this.detailList[0]?.lineDetails || [];
        this.showSettlementDetail = true;
      },
    },
  };
</script>
<style lang="scss" scoped></style>
